import { _ as _baseGetAllKeys } from "./auth-service-tools1245.js";
import { _ as _getSymbols } from "./auth-service-tools1246.js";
import { k as keys_1 } from "./auth-service-tools1227.js";
var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys = keys_1;

function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

var _getAllKeys = getAllKeys;
export { _getAllKeys as _ };